import $ from "jquery";
import Swiper, { Autoplay, Navigation, Pagination } from "swiper";
import { App } from "../../App";

import "./ID-Tag.less";

export class ProductIdTag {
    private readonly productsSwiper: Swiper;

    constructor() {
        new App();

        this.bindEvents();

        $(".smb-product-id-tag").toggleClass("smb-hide", false);

        Swiper.use([Navigation, Pagination, Autoplay]);

        this.productsSwiper = new Swiper(".smb-product-id-tag .smb-content-product .swiper-container", {
            autoplay: {
                delay: 3000,
                disableOnInteraction: true,
            },
            effect: "slide",
            loop: true,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            pagination: {
                bulletElement: "div",
                clickable: true,
                el: ".swiper-pagination",
                type: "bullets",
            },
            speed: 300,
        });
    }

    private bindEvents() {
        $(".smb-product-id-tag .smb-content-product .smb-product-select").on("click",
            (event: JQuery.TriggeredEvent): void => {
                const currentElement: JQuery<Element> = $(event.currentTarget);
                const selectedProduct: string = currentElement.attr("data-product") as string;
                const variationTextElement: JQuery<Element> = $(".smb-product-variation .smb-text");
                const priceTextElement: JQuery<Element> = $(".smb-product-display-container .smb-price-container .smb-price");

                $(".smb-product-id-tag .smb-content-product .smb-product-select").toggleClass("smb-is-active", false);
                currentElement.toggleClass("smb-is-active", true);

                let slideContent1: string = "";
                let slideContent2: string = "";

                switch (selectedProduct) {
                    case "id-tag-black":
                        slideContent1 = `<div class="swiper-slide smb-produkt-id-tag-frontside-black"></div>`;
                        slideContent2 = `<div class="swiper-slide smb-produkt-id-tag-backside-black"></div>`;
                        variationTextElement.text("ID-TAG black-gold");
                        priceTextElement.html("29,99&euro; *");
                        break;
                    case "id-tag-white":
                        slideContent1 = `<div class="swiper-slide smb-produkt-id-tag-frontside-white"></div>`;
                        slideContent2 = `<div class="swiper-slide smb-produkt-id-tag-backside-white"></div>`;
                        variationTextElement.text("ID-TAG white-silver");
                        priceTextElement.html("29,99&euro; *");
                        break;
                    case "duo-black":
                        slideContent1 = `<div class="swiper-slide smb-products-duo-frontside-black"></div>`;
                        slideContent2 = `<div class="swiper-slide smb-products-duo-backside-black"></div>`;
                        variationTextElement.text("ID-TAG & KEYKEEPER black edition");
                        priceTextElement.html("49,99&euro; *");
                        break;
                    case "duo-white":
                        slideContent1 = `<div class="swiper-slide smb-products-duo-frontside-white"></div>`;
                        slideContent2 = `<div class="swiper-slide smb-products-duo-backside-white"></div>`;
                        variationTextElement.text("ID-TAG & KEYKEEPER white edition");
                        priceTextElement.html("49,99&euro; *");
                        break;
                }

                this.productsSwiper.removeAllSlides();
                this.productsSwiper.appendSlide([slideContent1, slideContent2]);

                setTimeout(() => {
                    this.productsSwiper.update();
                    this.productsSwiper.slideToLoop(0, 0, false);
                }, 0);
            });

        $(".smb-product-id-tag .smb-content-product .smb-button").on("click",
            (event: JQuery.TriggeredEvent): void => {
                const activeProduct: string =
                    $(".smb-product-id-tag .smb-content-product .smb-product-select.smb-is-active")
                        .attr("data-product") as string;

                switch (activeProduct) {
                    case "id-tag-black":
                    case "id-tag-white":
                        window.open("https://rebirdished.de/produkt/id-tag/", "_blank");
                        break;
                    case "duo-black":
                    case "duo-white":
                        window.open("https://rebirdished.de/produkt/duo-edition/", "_blank");
                        break;
                }
            });
    }
}

$((): void => {
    if ($(".smb-product-id-tag").length > 0) {
        new ProductIdTag();
    }
});